var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('v-container',{attrs:{"fluid":""}},[_c('SchedulesCalender'),_c('ActionButton',{attrs:{"bottom":"","right":"","fixed":""},on:{"click":function($event){return _vm.$router.push({ name: 'AddSchedules' })}}},[_c('v-icon',[_vm._v("mdi-calendar-plus")])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }